/**
 * 草图实体删除提交原因。
 * 说明：删除可能来自 Delete 键、属性面板或后续其他入口，统一常量可以避免监听方耦合某个入口的字面量。
 */
export const SKETCH_ENTITY_DELETE_COMMIT_REASON = 'delete-sketch-entity';
